import React, { useState } from "react";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  CssBaseline,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ListItemIcon from "@mui/material/ListItemIcon";
import Dashboard from "./Dashboard";
import Leadmanagement from "./LeadsPart/Leadmanagement";
import ReferralsPoints from "./ReferralsPart/ReferralsPoints";
import ClientComponent from "./ClientsPart/ClientComponent";
import PartnersComponent from "./PartnersComponent";
import Interactionslist from "./Interactionslist";
import DroppedInt from "./DroppedInt";
import Insurance from "./Insurance";
import ManagementReferrals from "./ManagementReferrals";
import logo from "../../assets/Amigo logo blue bg.png";
// const Content = ({ selectedComponent, setSelectedComponent, isAdmin }) => {
//   switch (selectedComponent) {
//     case "Dashboard":
//       return <Dashboard setSelectedComponent={setSelectedComponent} />;
//     case "PartnersComponent":
//       return <PartnersComponent />;
//     case "ReferralsPoints":
//       return <ReferralsPoints />;
//     case "ManagementReferrals":
//       return <ManagementReferrals />;
//     case "Leadmanagement":
//       return <Leadmanagement />;
//     case "ClientComponent":
//       return <ClientComponent />;
//     case "Interactionslist":
//       return <Interactionslist />;
//     case "Insurance":
//       return <Insurance setSelectedComponent={setSelectedComponent} />;
//     case "DroppedInt":
//       return <DroppedInt />;
//     default:
//       return <Dashboard setSelectedComponent={setSelectedComponent} />;
//   }
// };

const Siderbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const roleId = +sessionStorage.getItem("roleId");
  const isAdmin = roleId === 1 || roleId === 6 || roleId === 7;
  const roleName = sessionStorage.getItem("roleName");
  const email = sessionStorage.getItem("email");
  const firstname = sessionStorage.getItem("firstname");
  const lastname = sessionStorage.getItem("lastname");
  const firstLetter = email ? email.charAt(0).toUpperCase() : "";

  // const currentPath =
  //   location.pathname === "/employeedashboard"
  //     ? ""
  //     : location.pathname.split("/").pop();
  const currentPath =
    location.pathname === "/employeedashboard"
      ? ""
      : location.pathname.startsWith("/employeedashboard/")
      ? location.pathname.substring("/employeedashboard/".length)
      : location.pathname.substring(1);
  const handleMainMenuClick = (path, hasSubMenu) => {
    if (!hasSubMenu) {
      navigate(path);
      setActiveSubmenu(null);
    } else {
      setActiveSubmenu(activeSubmenu === path ? null : path);
    }
  };

  const handleSubMenuItemClick = (path) => {
    navigate(path);
    // setActiveSubmenu(null);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/signin");
  };

  // Main menu items with paths
  const mainMenuItems = [
    {
      name: "Home",
      path: "",
      hasSubMenu: false,
      // subItems: [{ name: "Client Onboarding KYC", path: "client-onb-kyc" }],
    },

    {
      name: "Referrals",
      path: "referrals",
      hasSubMenu: true,
      subItems: [
        { name: "Partner Referrals", path: "referrals" },
        { name: "Management Referrals", path: "manage-referrals" },
        { name: "Add Referral", path: "referrals/add" },
      ],
    },
    {
      name: "Leads",
      path: "leads",
      hasSubMenu: true,
      subItems: [
        { name: "View All", path: "leads" },
        { name: "Add New", path: "leads/add" },
        // { name: "Add New" },
      ],
    },
    {
      name: "Clients",
      path: "clients",
      hasSubMenu: true,
      subItems: [
        { name: "View All", path: "clients" },
        { name: "Add New", path: "clients/add" },
        { name: "Incomplete KYC", path: "clients/incomplete-kyc-clients" },
      ],
    },

    {
      name: "Others",
      path: "interactions",
      hasSubMenu: true,
      subItems: [
        { name: "View Interactions", path: "interactions" },
        // { name: "Add Interactions" },
        { name: "Insurance", path: "insurance" },
        // { name: "Upload Documents" },
        { name: "Dropped Leads", path: "dropped-leads" },
        ...(isAdmin
          ? [{ name: "Wealth Advisors", path: "wealth-advisors" }]
          : []),
      ],
    },
    {
      name: "Partners",
      path: "partners",
      hasSubMenu: false,
      // subItems: [{ name: "View All", path: "partners" }],
    },
  ];

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        sx={{ backgroundColor: "#002C51", minHeight: "51px" }}
      >
        <Toolbar sx={{ minHeight: "48px" }}>
          {/* Brand/Logo on far left */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <img src={logo} alt="Logo" width="80px" />
            {/* <Typography sx={{ fontSize: "12px", marginTop: "-10px" }}>
              Amigo - The Customer Hub
            </Typography> */}
          </Box>

          {/* Centered Navigation */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexGrow: 1,
              justifyContent: "center",
            }}
          >
            {mainMenuItems.map((item, index) => (
              <Box key={index} sx={{ position: "relative" }}>
                <Box
                  sx={{
                    padding: "4px 12px",
                    cursor: "pointer",
                    color:
                      currentPath === item.path ||
                      activeSubmenu === item.path ||
                      // Add this line to check if current path matches any submenu item
                      (item.hasSubMenu &&
                        item.subItems &&
                        item.subItems.some(
                          (subItem) => currentPath === subItem.path
                        ))
                        ? "white"
                        : "rgba(255, 255, 255, 0.7)",
                    backgroundColor: "transparent",
                    borderBottom:
                      currentPath === item.path ||
                      activeSubmenu === item.path ||
                      // And also add the same check here for the border
                      (item.hasSubMenu &&
                        item.subItems &&
                        item.subItems.some(
                          (subItem) => currentPath === subItem.path
                        ))
                        ? "2px solid white"
                        : "2px solid transparent",
                    "&:hover": {
                      borderBottom: "2px solid rgba(255, 255, 255, 0.5)",
                    },
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={() =>
                    handleMainMenuClick(item.path, item.hasSubMenu)
                  }
                >
                  <Typography variant="body1" sx={{ fontSize: "13px" }}>
                    {item.name}
                  </Typography>
                  {item.hasSubMenu && (
                    <ArrowDropDownIcon
                      sx={{
                        ml: 0.5,
                        transform:
                          activeSubmenu === item.path
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        transition: "transform 0.3s",
                        fontSize: "18px", // Reduced size of the dropdown icon
                      }}
                    />
                  )}
                </Box>
              </Box>
            ))}
          </Box>

          {/* Profile Section on right */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Avatar
              sx={{
                width: "32px",
                height: "32px",
                bgcolor: "white",
                color: "#002C51",
                fontSize: "16px",
                cursor: "pointer",
              }}
              onClick={handleProfileMenuOpen}
            >
              {firstLetter}
            </Avatar>
            <Box
              sx={{
                ml: 1,
                // cursor: "pointer",
                display: "flex",
                flexDirection: "column",
              }}
              // onClick={handleProfileMenuOpen}
            >
              <Typography variant="body2">
                {firstname} {lastname}
              </Typography>
              <Typography variant="caption">{roleName}</Typography>
            </Box>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleProfileMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: "#002C51",
                  color: "white",
                },
              }}
            >
              <MenuItem onClick={handleLogout}>
                <ListItemIcon sx={{ color: "white" }}>
                  <LogoutOutlinedIcon />
                </ListItemIcon>
                <Typography>Logout</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Horizontal Submenu Bar */}
      {activeSubmenu && (
        <Box
          sx={{
            backgroundColor: "#002C51",
            display: "flex",
            justifyContent: "center",
            padding: "4px 0", // Reduced padding to decrease gap
            position: "relative",
            marginTop: "-4px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 1, // Reduced gap between submenu items
            }}
          >
            {mainMenuItems
              .find((item) => item.path === activeSubmenu)
              ?.subItems.map((subItem, subIndex) => (
                <Box
                  key={subIndex}
                  onClick={() => handleSubMenuItemClick(subItem.path)}
                  sx={{
                    padding: "4px 12px", // Reduced padding
                    cursor: "pointer",
                    color:
                      currentPath === subItem.path ||
                      currentPath.endsWith("/" + subItem.path)
                        ? "white"
                        : "rgba(255, 255, 255, 0.7)",
                    backgroundColor: "transparent", // Removed background color
                    borderBottom:
                      currentPath === subItem.path ||
                      currentPath.endsWith("/" + subItem.path)
                        ? "2px solid white"
                        : "2px solid transparent",
                    "&:hover": {
                      borderBottom: "2px solid rgba(255, 255, 255, 0.5)",
                    },
                  }}
                >
                  <Typography variant="body2" sx={{ fontSize: "13px" }}>
                    {subItem.name}
                  </Typography>
                </Box>
              ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Siderbar;
